import { t } from '@lingui/macro';

import store from '@/store';
import { p2pActions } from '@/store/p2p-slice';

import { closeP2PSocket, sendP2PSocketData } from './p2pConnection';

let intervalId: ReturnType<typeof setInterval> | null = null;

export const notAuthHandler = (
    uuid: string | null,
    clearIntervalID: boolean = false,
    rejected: boolean = false,
) => {
    if (rejected) {
        closeP2PSocket();
    }
    if (clearIntervalID) {
        if (intervalId) {
            clearInterval(intervalId);
            intervalId = null;
        }
        return;
    }

    if (uuid && uuid !== '') {
        store.dispatch(
            p2pActions.updatePeerFound(t`Waiting for admin's approval join`),
        );

        if (intervalId) return;
        sendP2PSocketData({
            command: 'notify-approval-request',
            data: uuid,
        });
        intervalId = setInterval(() => {
            sendP2PSocketData({
                command: 'notify-approval-request',
                data: uuid,
            });
        }, 20000);
    }
};
